import angular from 'angular';
import {
  loaderService,
  ssDialogService,
  orgDataService,
  userService,
  controlDataService,
  controlSharedModelService,
} from 'app/services';
import {
  alerts,
  importDocument,
  actionIcon,
  editControlTypeDialog
} from 'app/components/global';
import control from './control';
import editControlDialog from './dialog.editControlDialog';
import controller from './control-admin.controller';
import directive from './control-admin.directive';
import settingsDialog from './dialog.settingsDialog';
import controlMain from './controlMain';


export const controlAdminRouteConfig = {
  template: require('./control-admin.html'),
  controller: 'ControlAdminController',
  controllerAs: 'controlAdminVM',
};

export default angular.module('app.components.admin.controlAdmin', [
  alerts,
  actionIcon,
  editControlDialog,
  importDocument,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
  controlDataService,
  controlSharedModelService,
  control,
  settingsDialog,
  editControlTypeDialog,
  controlMain,
])
  .directive('controlAdmin', directive)
  .controller('ControlAdminController', controller)
  .name;

console.log('app.components.admin.controlAdmin created');
